import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/wz_bg.png'
import _imports_1 from '../assets/money_bg.png'
import _imports_2 from '../assets/to_info.png'
import _imports_3 from '../assets/yesterday.png'
import _imports_4 from '../assets/money.png'
import _imports_5 from '../assets/start_make.png'
import _imports_6 from '../assets/apptip.png'
import _imports_7 from '../assets/detail_close.png'


const _hoisted_1 = {
  id: "home",
  class: "home normal_width",
  style: {"padding-bottom":"20px","box-sizing":"border-box"}
}
const _hoisted_2 = { class: "normal_width" }
const _hoisted_3 = { class: "person_get" }
const _hoisted_4 = { style: {"color":"#FE1C1C","font-weight":"bold"} }
const _hoisted_5 = {
  class: "normal_width",
  style: {"padding":"0 18px","box-sizing":"border-box"}
}
const _hoisted_6 = { class: "normal_width home_usernew" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","position":"absolute","top":"0","left":"0"},
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_9 = { class: "home_top" }
const _hoisted_10 = { class: "normal_row" }
const _hoisted_11 = {
  style: {"flex-grow":"1","padding-right":"22px","box-sizing":"border-box"},
  class: "normal_width"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "normal_row home_top_price_title" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, "昨日收益"),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"21px","height":"21px"},
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_13 = { class: "home_top_price" }
const _hoisted_14 = { class: "normal_row" }
const _hoisted_15 = { style: {"font-size":"22px","line-height":"22px"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","line-height":"10px"} }, " 元", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "home_top_price_line" }, null, -1)
const _hoisted_18 = {
  style: {"flex-grow":"1","padding-left":"30px","box-sizing":"border-box"},
  class: "normal_width"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "normal_row home_top_price_title" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, "累计收益"),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"21px","height":"21px"},
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_20 = { class: "home_top_price" }
const _hoisted_21 = { class: "normal_row" }
const _hoisted_22 = { style: {"font-size":"22px","line-height":"22px"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","line-height":"10px"} }, " 元", -1)
const _hoisted_24 = {
  class: "normal_width start_make",
  style: {"padding":"0 18px","box-sizing":"border-box"}
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<img style=\"width:100%;position:absolute;top:0;left:0;\" src=\"" + _imports_5 + "\" alt=\"\"><div class=\"normal_row\"><div style=\"width:110px;\"></div><div class=\"home_in_tip\"><div class=\"home_in_tip_bg\">每日<span style=\"color:#FF4646;\">00:00</span>点刷新任务，120分钟看完可<span style=\"color:#FF4646;\">获得奖励</span></div></div></div>", 2)
const _hoisted_27 = { class: "normal_width home_in_item" }
const _hoisted_28 = { class: "normal_row" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  class: "home_in_info",
  style: {"margin-bottom":"8px"}
}
const _hoisted_31 = { class: "normal_row" }
const _hoisted_32 = { class: "home_in_info_name" }
const _hoisted_33 = { class: "home_in_info_btm" }
const _hoisted_34 = { style: {"font-weight":"bold"} }
const _hoisted_35 = { style: {"color":"#FF304E","font-size":"26px","font-weight":"bold","line-height":"26px"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11px","color":"#666666"} }, " 次", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"11px","color":"#666666"} }, "需观看广告", -1)
const _hoisted_38 = { class: "homeitem_in normal_row" }
const _hoisted_39 = {
  key: 0,
  style: {"flex-grow":"1"}
}
const _hoisted_40 = {
  key: 1,
  style: {"flex-grow":"1"}
}
const _hoisted_41 = {
  key: 2,
  style: {"flex-grow":"1","font-size":"12px"}
}
const _hoisted_42 = {
  key: 3,
  style: {"flex-grow":"1"}
}
const _hoisted_43 = { style: {"font-weight":"bold"} }
const _hoisted_44 = { key: 4 }
const _hoisted_45 = {
  key: 0,
  style: {"background":"#999999"},
  class: "homeitem_in_btn"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 5 }
const _hoisted_48 = {
  key: 0,
  style: {"background":"#999999"},
  class: "homeitem_in_btn"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { id: "home_dialog" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","position":"absolute","top":"-30px","left":"0"},
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "normal_row",
  style: {"justify-content":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "detailnew_wx",
    style: {"color":"#FE7B1C","font-size":"17px"}
  }, "任务步骤")
], -1)
const _hoisted_53 = { class: "normal_width" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", null, "第三步：【返回】轻应用赚开始任务", -1)

import { onMounted, ref,watch,computed } from "vue";
import { useRouter } from 'vue-router'

interface userItem {
  id: number,
  userId: number,
  userName: string,
  avaMoney: number,
  dayMoney: number,
  totalMoney: number
}
interface adTaskItem{
  id: number,
  channel: number,
  currTaskNum: number,
  lastTime: number,
  hasWatchNum: number,
  needWatchNum: number,
  needWatchTime: number,
  totalTaskNum: number,
  addTime: string
  name: string,
  icon: string,
  isOver: boolean
}
interface listItem{
  id: number,
  showOrder: number,
  userIcon: string,
  userId: string,
  userMoney: string,
  userName: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const FnjiApi:any = require('../api/api-example');
const CryptoJS = require('crypto-js');
const router = useRouter();

const service = ref(false);
const widthAll = computed(() => {
  return window.innerWidth;
})
const bgHeight = computed(() => {
  return window.innerWidth*0.94;
})
const openDetail = () => {
  let param = RC4Encrypt({userId: userId.value});
  router.push({path:'/detail',query:{userId: param}});
}

const towhere = (id:number,time:number,channel:number) => {
  // let param = CryptoJS.RC4.encrypt(JSON.stringify({userId: userId.value, adId: id}),'c8efb3ccc4266fdbbf8813d7c08ac73').toString();
  let param = RC4Encrypt({userId: userId.value, adId: id});
  if(time>0){
    FnjiApi.getTaskLinkApi({data: param}).then((data:any)=>{
      if(data.error===0){
          let dataInfo = RC4Decrypt(data.data);
          console.log(dataInfo);
          if(channel==2){
            window.location.href = dataInfo.link;
          }else{
            isDouyinInstalled(dataInfo.link,channel);
          }
      }
    })
  }else{
    FnjiApi.beginWatchAdApi({data: param}).then((datas:any)=>{
      getAllAdTask();
      FnjiApi.getTaskLinkApi({data: param}).then((data:any)=>{
        if(data.error===0){
          let dataInfo = RC4Decrypt(data.data);
          if(channel==2){
            window.location.href = dataInfo.link;
          }else{
            isDouyinInstalled(dataInfo.link,channel);
          }
        }
      })
    })
  }
}

const toVivo = (id: number,time:number) => {
  let param = RC4Encrypt({userId: userId.value, adId: id});
  // if (isQuickApp.value) {
    // alert('存在框架服务');
    if(time>0){
      FnjiApi.getTaskLinkApi({data: param}).then((data:any)=>{
        if(data.error===0){
            let dataInfo = RC4Decrypt(data.data);
            // window.location.href = dataInfo.link;
            window?.android?.Browser(dataInfo.link);
        }
      })
      // location.href = `https://hapjs.org/app/com.youge.xiaoke/pages/ad?userId=${userInfo.value?.userId}&adId=${id}`
    }else{
      FnjiApi.beginWatchAdApi({data: param}).then((datas:any)=>{
        getAllAdTask();
        FnjiApi.getTaskLinkApi({data: param}).then((data:any)=>{
          if(data.error===0){
              let dataInfo = RC4Decrypt(data.data);
              // window.location.href = dataInfo.link;
              window?.android?.Browser(dataInfo.link);
          }
        })
        // location.href = `https://hapjs.org/app/com.youge.xiaoke/pages/ad?userId=${userInfo.value?.userId}&adId=${id}`
      })
    }
    // location.href = `https://hapjs.org/app/com.youge.xiaoke/pages/ad?userId=${userInfo.value?.userId}&adId=${id}`
    // location.href = `hap://app/com.youge.xiaoke/pages/ad?userId=${userInfo.value?.userId}&adId=${id}`
    // appRouter('com.youge.xiaoke',
    //                'pages/ad',
    //                { userId: userInfo.value?.userId, adId: id })
  // }else{
  //   alert('快应用暂时仅支持vivo手机');
  // }
}

let tipAppName = ref('');
const isDouyinInstalled = (url:string,channel:number) => {
  let appstr = '';
  if(channel==1){
    appstr = "com.ss.android.ugc.aweme";
    tipAppName.value = '抖音';
  }else if(channel==3){
    appstr = "com.smile.gifmaker";
    tipAppName.value = '快手';
  }
  if (!checkInstalledApp(appstr)) {
    service.value = true;
    return
  }
  window.location.href = url;
}

const checkInstalledApp = (e:any) => {
    return window && window.android && window.android.isInstallApk ? window.android.isInstallApk(e) : !1
}
const checkRunningApplication = (e:any) => {
    return window && window.android && window.android.isRunningApplication ? window.android.isRunningApplication(e) : !1
}

let allInfo = ref({
  appId: '',
  hzToken: '',
  name: '',
  sdkVerCode: '',
  uid: '',
  chUuid: '',
  cid: '',
  devId: '',
  memberId: '',
  userId: ''
});
let userId = ref();
let queryString = ref('');
const getUrlInfo = () => {
  service.value = false;
  const url = window.location.href;
  queryString.value = url.split('?')[1];
  const params: Record<string, string> = {}; // 使用 Record 类型来指定索引签名
  // queryString.value = 'data=e8755c1db07571485bf46918978f39cd18db67e9b0083915c5e598e3043d43d2ad0551a59113b6783ce6be6a1903b04e47db32112be7b0a88830504a2967919512c40c217d72fe107f78a1dd97a139db243e45fd4ce7e5b88ee4d994e0d690f88dbc05e009cfc68bee176b1fb251b2&appid=10075&uid=eaa5addb17bf4ded98e197995e119be2&name=%E7%8E%A9%E8%B5%9A%E9%83%A8%E8%90%BD&sdkVerCode=41150&hzToken=5dfe4a49-e068-4394-8239-2eba16c3aeb5';
  // alert(queryString.value)
  if (queryString) {
    const urlParams = new URLSearchParams(queryString.value);
    for (let param of urlParams.entries()) {
      params[param[0]] = param[1];
    }
    let data = queryString.value.split('&')[0].split('data=')[1];
    console.log(data);
    
    console.log(params); // 输出 params 对象
    // console.log('data:',params['data']);
    // console.log(RC4DecryptUrl(params['data']));
    const info = RC4DecryptUrl(data);
    allInfo.value.appId = info.appId;
    allInfo.value.hzToken = params['hzToken'];
    allInfo.value.name = params['name'];
    allInfo.value.sdkVerCode = params['sdkVerCode'];
    allInfo.value.uid = params['uid'];
    allInfo.value.chUuid = info.chUuid;
    allInfo.value.cid = info.cid;
    allInfo.value.devId = info.devId;
    allInfo.value.memberId = info.memberId;
    allInfo.value.userId = info.userId;
    userId.value = info.userId;
    getUserInfo()
    getAllAdTask()
    getShowOrder()
  }
}

let userInfo = ref<userItem>();
const getUserInfo = () => {
  let param = RC4Encrypt(allInfo.value);
  FnjiApi.getUserInfoApi({data: param}).then((data:any)=>{
    let dataInfo = RC4Decrypt(data.data);
    userInfo.value = dataInfo;
  })
}

let adTaskList = ref<adTaskItem[]>([]);
const getAllAdTask = () => {
  let param = RC4Encrypt({userId: userId.value});
  FnjiApi.getAllAdTaskApi({data: param}).then((data:any)=>{
    let dataInfo = RC4Decrypt(data.data);
    adTaskList.value = dataInfo;
  })
}

let moneyList = ref<listItem[]>([]);
let realTimeMoney = ref<listItem[]>([]);
let totalInfo = ref({money: 0,num: 0,icon: []});
const getShowOrder = () => {
  let param = RC4Encrypt({userId: userId.value});
  FnjiApi.getShowOrderApi({data: param}).then((data:any)=>{
    let dataInfo = RC4Decrypt(data.data);
    moneyList.value = dataInfo.moneyList;
    realTimeMoney.value = dataInfo.realTimeMoney;
    totalInfo.value = dataInfo.totalMoney;
  })
}

const RC4Encrypt = (data:any) =>{
  const key = "c8efb3ccc4266fdbbf8813d7c08ac732";
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const message = JSON.stringify(data);
  // 加密
  const encrypted = CryptoJS.RC4.encrypt(message, keyHex);
  // 转换为字符串（Base64）
  const base64Encrypted = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  return base64Encrypted;
}

const RC4Decrypt = (sign:any) =>{
  try {
    // 密钥和密钥(hex)
    const key = "c8efb3ccc4266fdbbf8813d7c08ac732";
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    // 解密
    const decryptedBytes = CryptoJS.RC4.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(sign)
    }, keyHex);

    // 转换为字符串
    const decryptedMessage = decryptedBytes.toString(CryptoJS.enc.Utf8);
    // console.log(decryptedMessage); // "Your Message Here"
    const decryptedJson = JSON.parse(decryptedMessage);
    // console.log(decryptedJson);
    return decryptedJson;
  } catch (e) {
    console.error("解密后的消息不是有效的JSON:", e);
    return "";
  }
}

const RC4DecryptUrl = (sign:any) =>{
  try {
    // 密钥和密钥(hex)
    const key = "5BC4877044791061F373A96E2BA55208";
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    // 解密
    const decryptedBytes = CryptoJS.RC4.decrypt({
        ciphertext: CryptoJS.enc.Hex.parse(sign)
    }, keyHex);

    // 转换为字符串
    const decryptedMessage = decryptedBytes.toString(CryptoJS.enc.Utf8);
    // console.log(decryptedMessage); // "Your Message Here"
    const decryptedJson = JSON.parse(decryptedMessage);
    // console.log(decryptedJson);
    return decryptedJson;
  } catch (e) {
    console.error("解密后的消息不是有效的JSON:", e);
    return "";
  }
}

const RC4DecryptNew = () => {
  let key = CryptoJS.enc.Utf8.parse('c8efb3ccc4266fdbbf8813d7c08ac73');
  let param = CryptoJS.RC4.encrypt(JSON.stringify({userId: userId.value}),key,{
                iv : '',
                mode : CryptoJS.mode.CBC,
                padding : CryptoJS.pad.Pkcs7
            }).toString();
  console.log(222222);
  console.log(param);
  console.log(22222);
  console.log(CryptoJS.RC4.decrypt(param,key,{
                iv : '',
                mode : CryptoJS.mode.CBC,
                padding : CryptoJS.pad.Pkcs7
            }).toString(CryptoJS.enc.Utf8));
}

const isQuickApp = ref(false);
onMounted(()=>{
  getUrlInfo();
  // channelReady(function(bAvailable) {
  //   console.log(bAvailable);
    
  //   isQuickApp.value = bAvailable;
  // });
  (window as any).onPageResume = () => {
    getUrlInfo();
  };
})


return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_duv = _resolveComponent("duv")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      style: _normalizeStyle([{height: _unref(bgHeight)+'px'}, {"width":"100vw","position":"absolute","top":"0","left":"0"}]),
      src: _imports_0,
      alt: ""
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "normal_width",
        style: _normalizeStyle([{"padding":"0 18px","box-sizing":"border-box"}, {paddingTop: 0.38*_unref(bgHeight)+'px'}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_carousel, {
            style: {"width":"100%"},
            height: "17px",
            direction: "vertical",
            "motion-blur": "",
            autoplay: true,
            "indicator-position": "none"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(realTimeMoney), (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode("恭喜" + _toDisplayString(item.userName) + "获得", 1),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.userMoney), 1),
                      _createTextVNode("元")
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ], 4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", { class: "normal_row home_usernew_to" }, [
            _hoisted_8,
            _createElementVNode("div", { onClick: openDetail }, "查看明细"),
            _createElementVNode("img", {
              onClick: openDetail,
              style: {"width":"15px","height":"15px"},
              src: _imports_2,
              alt: ""
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(userInfo)?.dayMoney), 1),
                      _hoisted_16
                    ])
                  ])
                ])
              ]),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(userInfo)?.totalMoney), 1),
                      _hoisted_23
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adTaskList), (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("img", {
                style: {"width":"42px","height":"42px","border-radius":"8px"},
                src: `https://omsv2-static.fnji.com/${item.icon}`,
                alt: ""
              }, null, 8, _hoisted_29),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(item.name) + "广告赚（" + _toDisplayString(item.hasWatchNum) + "/" + _toDisplayString(item.needWatchNum) + "）", 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createTextVNode("剩余单数："),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(item.currTaskNum), 1)
                ])
              ]),
              _createVNode(_component_duv, { class: "home_in_right" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createTextVNode(_toDisplayString(item.needWatchNum>0?item.needWatchNum:''), 1),
                    _hoisted_36
                  ]),
                  _hoisted_37
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_38, [
              (item.isOver)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, "请于明日参加"))
                : (item.lastTime>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, "剩余时间：" + _toDisplayString(item.lastTime) + "分钟", 1))
                  : (item.channel==4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "打开【快应用(仅支持vivo手机)】"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createTextVNode("做任务时，需打开"),
                        _createElementVNode("span", _hoisted_43, "【" + _toDisplayString(item.name) + "】", 1)
                      ])),
              (item.channel!=4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (item.isOver||item.currTaskNum==0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, "已抢完"))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (towhere(item.id,item.lastTime,item.channel)),
                          class: "homeitem_in_btn"
                        }, "点击观看", 8, _hoisted_46))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    (item.isOver||item.currTaskNum==0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, "已抢完"))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (toVivo(item.id,item.lastTime)),
                          class: _normalizeClass([{begin:item.lastTime>0}, "home_btn home_btn_on"])
                        }, "秒开", 10, _hoisted_49))
                  ]))
            ])
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createVNode(_component_el_dialog, {
        modelValue: service.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((service).value = $event)),
        width: "292",
        style: {"height":"180px","border-radius":"16px","margin-top":"230px"},
        center: "",
        "show-close": false
      }, {
        default: _withCtx(() => [
          _hoisted_51,
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (service.value=false)),
            style: {"width":"37px","height":"37px","position":"absolute","bottom":"-53px","left":"127px"},
            src: _imports_7,
            alt: ""
          }),
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", null, "第一步：【下载】" + _toDisplayString(_unref(tipAppName)), 1),
            _createElementVNode("div", null, "第二步：【打开】" + _toDisplayString(_unref(tipAppName)) + "APP，并登录账号", 1),
            _hoisted_54
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})